import { Controller } from "@hotwired/stimulus"

// Submits the form (e.g. when a filter <select> changes).
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
